import React from 'react';
import { Route } from 'react-router-dom';
import { METIER_SLUGS } from '../pages/MetierLanding/metiersData';
import {
  clientRouterHubLocales,
  LOCALE_ROUTE_PREFIX,
} from '../config/localeRoutes';

type MetierShortRoutesProps = {
  MetierLanding: React.ComponentType;
};

type MetierShortCityRoutesProps = {
  MetierCityLanding: React.ComponentType;
};

/**
 * URLs métier sans segment /services/ — ex. /educateur-canin/, /it/educateur-canin/ (#1120).
 */
export function frMetierShortRouteElements({
  MetierLanding,
}: MetierShortRoutesProps): React.ReactNode[] {
  return METIER_SLUGS.map((slug) => (
    <Route key={`fr-metier-short-${slug}`} path={`/${slug}`} element={<MetierLanding />} />
  ));
}

/** Routes courtes métier + ville — ex. /pension-canine/lyon (#1087, #1120). */
export function frMetierShortCityRouteElements({
  MetierCityLanding,
}: MetierShortCityRoutesProps): React.ReactNode[] {
  return METIER_SLUGS.map((slug) => (
    <Route
      key={`fr-metier-short-city-${slug}`}
      path={`/${slug}/:citySlug`}
      element={<MetierCityLanding />}
    />
  ));
}

export function localizedMetierShortRouteElements({
  MetierLanding,
}: MetierShortRoutesProps): React.ReactNode[] {
  return clientRouterHubLocales().flatMap((locale) => {
    const prefix = LOCALE_ROUTE_PREFIX[locale];
    if (!prefix) return [];
    return METIER_SLUGS.map((slug) => (
      <Route
        key={`${locale}-metier-short-${slug}`}
        path={`${prefix}/${slug}`}
        element={<MetierLanding />}
      />
    ));
  });
}

export function localizedMetierShortCityRouteElements({
  MetierCityLanding,
}: MetierShortCityRoutesProps): React.ReactNode[] {
  return clientRouterHubLocales().flatMap((locale) => {
    const prefix = LOCALE_ROUTE_PREFIX[locale];
    if (!prefix) return [];
    return METIER_SLUGS.map((slug) => (
      <Route
        key={`${locale}-metier-short-city-${slug}`}
        path={`${prefix}/${slug}/:citySlug`}
        element={<MetierCityLanding />}
      />
    ));
  });
}
